module.exports = __webpack_public_path__ + "static/english_circle_4-404e5318fe7332ef4800939a1df2355c.svg";